import React from 'react';
import { Reveal } from '../Reveal';
import { LaunchOfferBlock } from '../LaunchOffer';
import { CTAButton } from '../CTAButton';
export function FinalCTA() {
  return <section className="relative overflow-hidden border-b border-line bg-ink py-[60px] lg:py-[100px]" data-id="element-95" data-mp="5f3cgie1lti1">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_50%,rgba(255,159,28,0.14)_0%,rgba(10,15,30,0)_75%)]" aria-hidden="true" data-id="element-96" data-mp="3rsv7c2mp31el" />
      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-10" data-id="element-97" data-mp="3dvgd8klhy5ga">
        <Reveal data-id="element-98" data-mp="3hw08fimieyzs">
          <h2 className="text-3xl font-bold leading-[1.1] tracking-tight text-gold sm:text-[44px]" data-id="element-99" data-mp="3hsceiid5kakj">
            El próximo lunes puede ser diferente.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[17px] leading-[1.7] text-cool" data-id="element-100" data-mp="38usch77gua8v">
            420+ páginas de protocolos accionables, 6 bonos incluidos y acceso en
            menos de 5 minutos.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-10" data-id="element-101" data-mp="170jjdljgcs1k">
          <LaunchOfferBlock data-id="element-102" data-mp="q7txzee4g4d5" />
        </Reveal>

        <Reveal delay={0.1} className="mx-auto mt-10 max-w-md" data-id="element-103" data-mp="q6it1b8xwqkg">
          <CTAButton pulse contentName="Programa Atleta Corporativo" value={24990} data-id="element-104" data-mp="l8r3uozojijy">
            Quiero acceder ya mismo
          </CTAButton>
          <p className="mt-3 text-[12px] text-cool" data-id="element-105" data-mp="z2rsur0txr74">
            Pago seguro vía nuestra plataforma de checkout
          </p>
        </Reveal>
      </div>
    </section>;
}